import BookingSessionProvider from "../../context/BookingSession";
import CheckInProvider from "../../context/Checkin";
import StaffInfoProvider from "../../context/Staff";
import { TBookingType } from "../../interfaces";
import { PageLayout } from "../../layouts";
import Header from "./Header";
import SessionTable from "./SessionTable";
import useDashboard from "./useDashboard";
import ModalProvider from "../../context/Modal";
import { RaceHostSelectionProvider } from "../../context/RaceHostSelection";
import SessionScheduleContextProvider from "../../context/SessionSchedule";
import { DateTime } from "luxon";
import { useMemo } from "react";
import BattleKartContextProvider from "../../context/BattleKart";

export const Dashboard = () => {
  const { view, selectedDate, dashboardView, ageFilter, battleKartGameFilter, wetherData, isItemExchangeEnable, changeDashboardView, changeSelectedDate, changeView, changeAgeFilter, changeBattleKartGameFilter, changeIsItemExchangeEnable } = useDashboard();
  const dateStr = useMemo(() => DateTime.fromJSDate(selectedDate).toFormat("yyyy-MM-dd"), [selectedDate]);

  return (
    <SessionScheduleContextProvider date={dateStr} track={view}>
      <RaceHostSelectionProvider date={selectedDate}>
        <BattleKartContextProvider date={dateStr}>
          <BookingSessionProvider date={selectedDate} track={view} wetherData={wetherData} withDraftOrders>
            <StaffInfoProvider date={selectedDate}>
              <CheckInProvider date={selectedDate}>
                <ModalProvider>
                  <PageLayout
                    Header={
                      <Header
                        view={view}
                        selectedDate={selectedDate}
                        changeView={(val) => {
                          changeView(val as TBookingType);
                        }}
                        changeSelectedDate={changeSelectedDate}
                        changeDashboardView={changeDashboardView}
                      />
                    }
                  >
                    <SessionTable dashboardView={dashboardView} ageFilter={ageFilter} battleKartGameFilter={battleKartGameFilter} isItemExchangeEnable={isItemExchangeEnable} changeAgeFilter={changeAgeFilter} changeBattleKartGameFilter={changeBattleKartGameFilter} changeIsItemExchangeEnable={changeIsItemExchangeEnable} />
                  </PageLayout>
                </ModalProvider>
              </CheckInProvider>
            </StaffInfoProvider>
          </BookingSessionProvider>
        </BattleKartContextProvider>
      </RaceHostSelectionProvider>
    </SessionScheduleContextProvider>
  );
};
